import "@/assets/reset.css";
import "@/assets/theme/index.css";
import Vue from "vue";
import store from "./store";
import router from "./router";
import ElementUI, { Message } from "element-ui";
import App from "./App.vue";
import MBuy from "@/components/Mbuy.vue";
import MyHeader from "@/components/header";
import MyFooter from "@/components/footer";
import VueAwesomeSwiper from "vue-awesome-swiper";
import MyTools from "@/components/rightTools";
import 'swiper/dist/css/swiper.css'
Vue.config.productionTip = false;
// 引入弹窗页面
//import MyTotal from '@/components/memberBug/index.vue'
//引入协议页面
import userProtocol from "./views/userProtocol"

import Vant from 'vant';
import 'vant/lib/index.css';
import '@/common/ployfill'


Vue.use(Vant);

/*
swiper 旧版本文档地址
https://github.com/surmon-china/vue-awesome-swiper
https://github.surmon.me/vue-awesome-swiper/
*/
import VueClipBoard from 'vue-clipboard2'
import { setInterval } from "core-js";
Vue.use(VueClipBoard)

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)

Vue.component("m-buy", MBuy);
Vue.component("m-header", MyHeader);
Vue.component("m-footer", MyFooter);
Vue.component("m-tools", MyTools);
//Vue.component("m-Total", MyTotal);
Vue.component("m-userPro", userProtocol);

router.beforeEach((to, from, next) => {
  /* 三方登陆账号被禁用 */
  if (to.query.loginban) {
    if (to.query.loginban == 90013) {
      Message({
        message: '您的账户已被禁止登陆，如有疑问请联系客服',
        type: "error",
        duration: 5 * 1000,
      });
      next({ path: '/login' });
      return false;
    }
  }
  /* 三方登陆或者注册有token */
  if (to.query.token) {
    store.commit('SET_USER_INFO', {
      token: to.query.token
    });

    if (to.query.marker && to.query.marker != 'symbol') {
      next({ path: to.query.marker });
    } else {
      next({ path: "/user/account" });
    }

    return false;
  }
  
  if(store.getters.GET_USER_INFO.token === ''){
     localStorage.removeItem('memberState')
  }
  const { token = '' } = store.getters.GET_USER_INFO;
  
  

  /* 如果访问用户中心且未登录 */
  if (to.path.indexOf('/user') > -1 && !token) {
    next({ path: '/login' });
    return false;
  }

  // 如果已登录访问登录页面
  if (token && to.path === '/login') {
    next({ path: '/user/account' });
    return false;
  }

  //加入百度统计 2022/11/30
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  // 百度统计结束
  next();
})




const app = new Vue({
  router,
  store,
  render: (h) => h(App),
});

app.$mount("#app");
